import { ComponentSettings } from './types';

export const defaultSettings: ComponentSettings = {
  billingHistory: {
    enableFiltering: true,
    paginationVariant: 'simple',
    itemsPerPage: 12,
    visibleColumns: [
      'invoice_number',
      'issue_date',
      'total_amount',
      'amount_due',
      'status',
    ],
  },
};
